import React from 'react';

const ContactsSection = () => (
  <section className="contacts">
    <h3>Contacts</h3>

    <div className="contacts-list">
      <div className="contact">
        <h4>General Information</h4>
        <p>bst.geral@bst.pt</p>
      </div>

      <div className="contact">
        <h4>Support</h4>
        <p>support@bst.pt</p>
      </div>
    </div>
    <div className="contacts-list">
      <div className="contact">
        <h4>J. Silva Pinto</h4>
        <i>Chief Executive Officer</i>
        <p>jcspinto@bst.pt</p>
      </div>

      <div className="contact">
        <h4>Jack Albuquerque</h4>
        <i>Chief Operating Officer</i>
        <p>jack.albuquerque@bst.pt</p>
      </div>
    </div>
  </section>
);

export default ContactsSection;
